import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listInventoryPokemons } from "@/services/inventory/list-inventory-pokemons";
import { queryKeys } from "./query-keys";

export const useInventoryPokemons = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.inventoryPokemons,
    queryFn: async () => {
      const response = await listInventoryPokemons();
      if (!response.ok) throw new Error(response.message);
      return response.data.player_pokemons;
    },
    enabled: state.status === "authenticated",
  });
};
